import { url } from "../../client/Actions";

const utils = {
  isEquals: (f, v) => {
    return f === v;
  },
  isNonEmpty: (v) => {
    return (v == false && v !== "" || v && v !== "none" && v !== "") ? true : false;
  },
  isNonNull: (v) => {
    return (v && v !== "") ? true : false;
  },
  isNull: (v) => {
    return (v === null) ? true : false;
  },
  renderTabletPress: (tabletPress) => {
    return tabletPress ?
      renderWithNameObject(tabletPress.manufacturer) +
      renderWithNameObject(tabletPress.model) +
      renderWithNameObject(tabletPress.toolStandard) +
      (tabletPress.matrixOrSegment == "SEGMENT" ? "Segment " : "Matryca ") +
      (tabletPress.matrixOrSegment == "MATRIX" && utils.isNonNull(tabletPress.matrixStandard) ? tabletPress.matrixStandard.name + " " : "") +
      tabletPress.serialNumber
      : "";
  },
  defaultUrl: () => {
    return url();
  },
  numberWithSpaces: (v) => {
    return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  },
  isToggled: () => {
    return localStorage.getItem("toggled") === "true";
  },
  truncateText: (text, wordLimit = 7) => {
    const words = text.split(" ");

    // Check if it's a single big word (no spaces)
    if (words.length === 1) {
      return text.length > wordLimit
        ? text.slice(0, wordLimit) + "..."
        : text;
    }

    // Truncate based on word limit
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  },
  openFile: (filePath) => {
    window.open(utils.defaultUrl() + filePath, "_blank", "width=1100,height=400px,resizable=1");
  },
  join: (values) => {
    return values.map(v => v + "").join("")
  },
};

const renderWithNameObject = (obj) => {
  return obj ? obj.name + " " : "";

};

export const eventDirectButton = [
  {
    events: ["CLEANING","CONSERVATION","MEASUREMENT","POLISHING","REPAIR","STORAGE"],
    title: "Do zarządzania",
    url: (event) => "/tool/management/" + event.toolSetId
  },
  {
    events: ["PRODUCTION_START","PRODUCTION_END"],
    title: "Do produkcji",
    url: (event) => "/production/edit/" + event.additionalId
  }

];



export default utils;
